import gql from 'graphql-tag';

export const creatorFragment = gql`
  fragment showCreator on ShowCreator {
    id
    name
    link
    role
  }
`;

export const ratingsFragment = gql`
  fragment ratings on ShowRatings {
    link
    count
    rating
  }
`;

export const supportedLinksFragment = gql`
  fragment link on SupportedLink {
    id: slug
    slug
    label
    type
    generatedType
    order
    isDefault
  }
`;

export const linksFragment = gql`
  fragment link on Link {
    id: slug
    slug
    label
    type
    generatedType
    order
    link
    isCustom
    isDefault
    isHidden
  }
`;

export const episodeFragment = gql`
  fragment episode on Episode {
    guid
    title
    description
    explicit
    image
    published
    duration
    copyright
    enclosure {
      filesize
      type
      url
    }
  }
`;

export const showFragment = gql`
  fragment showBase on Show {
    id
    itunesId
    vanityUrl
    isActive
    title
    publisher
    image
  }
`;
